import { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import { getContent } from '../../services';
import parse from 'html-react-parser';
import './Penghargaan.css';
import moment from 'moment';

const div1: object = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 10,
};

const titleDiv: object = {
  width: '80%',
  fontSize: 24,
  textAlign: 'center',
  fontWeight: 'bold',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

const containDiv: object = {
  height: 160,
  textAlign: 'center',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 9,
  WebkitBoxOrient: 'vertical',
};

const PenghargaanContain = ({ isId, handleOpenModal }: any) => {
  const itemsPerPage = 8;
  const [page, setPage] = useState(1);
  const [dataAchiev, setDataAchiev] = useState([]);

  const totalPages = Math.ceil(dataAchiev.length / itemsPerPage);

  useEffect(() => {
    getContent(3, 8, page, '').then((res) => {
      setDataAchiev(res.data.rows);
    });
  }, [page]);

  return (
    <div>
      <Grid container spacing={3}>
        {dataAchiev.length > 0 ? (
          dataAchiev?.map((data: any) => (
            <Grid item xs={12} sm={6} md={3}>
              <Card
                className='custom-card'
                onClick={() => handleOpenModal(data)}
              >
                <CardContent>
                  <div style={div1}>
                    <div style={{ height: 110 }}>
                      <img
                        src={`${process.env.REACT_APP_URL}/images/${data.image}`}
                        alt={data.title_id}
                        style={{ height: 100 }}
                      />
                    </div>
                  </div>
                  <div style={div1}>
                    <div style={titleDiv}>
                      {isId ? data.title_id : data.title_en}
                    </div>
                  </div>
                  <div style={div1}>
                    <div style={containDiv}>
                      {parse(isId ? data.content_id : data.content_en)}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} style={{ height: 300 }}>
            <Typography
              align='center'
              color='textSecondary'
              style={{ marginTop: 100 }}
            >
              {isId ? 'Belum ada data penghargaan' : 'No data achievement yet'}
            </Typography>
          </Grid>
        )}
      </Grid>
      {dataAchiev.length > 0 && (
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}
        >
          <Pagination
            count={totalPages}
            color='secondary'
            variant='outlined'
            shape='rounded'
            page={page}
            onChange={(e, value) => setPage(value)}
          />
        </div>
      )}
    </div>
  );
};

const imgModalDiv: object = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 300,
};

const mainTextModalDiv: object = {
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  height: '275px',
};

const dateModalDiv: object = {
  textAlign: 'right',
  marginTop: 10,
  color: 'gray',
  fontSize: 12,
  fontStyle: 'italic',
};

const ModalPenghargaan = ({ open, dataModal, handleCloseModal }: any) => {
  const { image, title, content, date } = dataModal;
  return (
    <Dialog open={open} fullWidth maxWidth='md' onClose={handleCloseModal}>
      <DialogContent style={{ paddingTop: 30, paddingBottom: 30 }}>
        <Grid container spacing={3} justifyContent='center'>
          <Grid item xs={12} md={4}>
            <div style={imgModalDiv}>
              <img src={image} alt={title} style={{ width: '100%' }} />
            </div>
          </Grid>
          <Grid item xs={12} md={8}>
            <div style={mainTextModalDiv}>
              <div style={{ width: '100%' }}>
                <Typography
                  variant='h5'
                  color='secondary'
                  align='justify'
                  style={{ fontWeight: 'bold', marginBottom: 10 }}
                >
                  {title}
                </Typography>
                <Typography align='justify'>{parse(content)}</Typography>
              </div>
            </div>
            <p style={dateModalDiv}>
              Upload : {moment(date).format('DD MMMM YYYY')}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export const Penghargaan = ({ isId }: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [dataModal, setDataModal] = useState({
    image: '',
    title: '',
    content: '',
    date: '',
  });

  const handleOpenModal = (data: any) => {
    setDataModal({
      image: `${process.env.REACT_APP_URL}/images/${data.image}`,
      title: isId ? data.title_id : data.title_en,
      content: isId ? data.content_id : data.content_en,
      date: data.created_at,
    });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setDataModal({
      image: '',
      title: '',
      content: '',
      date: '',
    });
  };

  return (
    <div
      style={{
        maxWidth: 1280,
        margin: '0 auto',
        padding: '0 16px',
        paddingBottom: '5rem',
      }}
    >
      <Typography style={{ marginBottom: '4rem' }}>
        {isId ? 'Tentang Kami' : 'About Us'}
        &nbsp; &gt; &nbsp;{' '}
        <span style={{ color: '#e3232a' }}>
          {isId ? 'Penghargaan' : 'Achievements'}
        </span>
      </Typography>
      <Typography
        color='secondary'
        variant='h4'
        align='center'
        style={{ marginBottom: 32 }}
      >
        {isId ? 'Penghargaan Kami' : 'Our Achievements'}
      </Typography>
      <PenghargaanContain isId={isId} handleOpenModal={handleOpenModal} />
      <ModalPenghargaan
        open={openModal}
        dataModal={dataModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
};
